import React, { useMemo, useState } from 'react';
import { Input, Pagination, Divider, Spin } from 'antd';
import { WithLatestStateDeviceNode } from '../RootTree';
import { LoadingOutlined } from '@ant-design/icons';

export const GroupCameras = ({
  cameras,
  currentPage,
  pageSize,
  onPageChange,
  isLoading,
  getIsCameraPinned,
  onPinCamera,
  total,
  selectedSerial,
  onSelectCamera,
}) => {
  const searchPageSize = 15;
  const [search, setSearch] = useState('');
  const [searchPage, setSearchPage] = useState(1);
  const searchResult = useMemo(() => {
    if (!search) {
      return cameras;
    }

    return cameras?.filter((cam) =>
      cam.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [cameras, search]);

  const handleSearch = (value) => {
    setSearch(value);
    setSearchPage(1);
  };

  const camerasToDisplay = useMemo(() => {
    if (!search) {
      return cameras?.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
      );
    }

    return searchResult?.slice(
      (searchPage - 1) * searchPageSize,
      searchPage * searchPageSize
    );
  }, [
    search,
    searchResult,
    currentPage,
    pageSize,
    searchPage,
    searchPageSize,
    cameras,
  ]);

  const finalCurrentPage = useMemo(() => {
    if (!search) {
      return currentPage;
    }

    return searchPage;
  }, [search, searchPage, currentPage]);

  const finalTotal = useMemo(() => {
    if (!search) {
      return total;
    }

    return searchResult?.length || 0;
  }, [search, searchResult, total]);

  const handlePageChange = (page, pageSize) => {
    if (!search) {
      onPageChange(page, pageSize);
    } else {
      setSearchPage(page);
    }
  };

  const finalPageSize = useMemo(() => {
    if (!search) {
      return pageSize;
    }

    return searchPageSize;
  }, [search, pageSize, searchPageSize]);
  return (
    <>
      <Input.Search
        placeholder="Search this group"
        onSearch={handleSearch}
        defaultValue={search}
        loading={isLoading}
        allowClear
      />
      <Divider className="camera-list-divider" />
      <div className="camera-list">
        {isLoading && (
          <div className="camera-list-loading">
            <Spin indicator={<LoadingOutlined />} />
          </div>
        )}
        {!isLoading && (
          <React.Fragment>
            <div className="camera-list-items">
              {camerasToDisplay?.map((cam) => (
                <WithLatestStateDeviceNode
                  key={cam.serial}
                  name={cam.name}
                  serial={cam.serial}
                  state={cam.state}
                  isPinned={getIsCameraPinned?.(cam.serial) || false}
                  onPin={(pinned) => onPinCamera(cam, pinned)}
                  isSelected={selectedSerial === cam.serial}
                  onSelect={() => onSelectCamera(cam)}
                />
              ))}
            </div>

            <div className="camera-list-pagination">
              <Pagination
                size="small"
                showSizeChanger={false}
                total={finalTotal}
                current={finalCurrentPage}
                pageSize={finalPageSize}
                onChange={handlePageChange}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    </>
  );
};
